import React, { useState, useEffect, useRef } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { Modal, Button } from "react-bootstrap";
import { QRCodeCanvas } from "qrcode.react";
import html2pdf from "html2pdf.js";


const API_URL = "https://sunrise-backend.sunrisemeditechsystems.com/api";

export default function ProductDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [orderType, setOrderType] = useState("buy");
  const [productType, setProductType] = useState("repair");
  const [quantity, setQuantity] = useState(1);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [hospitalName, setHospitalName] = useState("");
  const [doctorName, setDoctorName] = useState("");
  const [doctorPhone, setDoctorPhone] = useState("");
  const [receiverName, setReceiverName] = useState("");
  const [receiverPhone, setReceiverPhone] = useState("");
  const [photo, setPhoto] = useState("");
  const [hospitalAddress, setHospitalAddress] = useState("");
  const [notes, setNotes] = useState("");
  const [showOrderForm, setShowOrderForm] = useState(false);
  const [userData, setUserData] = useState(null);
  const [showQRModal, setShowQRModal] = useState(false);
  const [qrValue, setQrValue] = useState("");

  useEffect(() => {
    const userDataStr = localStorage.getItem("userData");
    let userData = null;
    if (userDataStr && userDataStr !== "undefined") {
      userData = JSON.parse(userDataStr);
    }
    setUserData(userData);
  }, []);

  useEffect(() => {
    fetchProduct();
  }, [id]);

  const fetchProduct = async () => {
    try {
      const response = await axios.get(`${API_URL}/products/${id}`);
      setProduct(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching product:", error);
      Swal.fire("Error", "Failed to fetch product details", "error");
      setLoading(false);
    }
  };

  const calculateTotal = () => {
    if (!product) return 0;
    if (orderType === "buy") {
      return product.salePrice * quantity;
    } else {
      if (!startDate || !endDate) return 0;
      const start = new Date(startDate);
      const end = new Date(endDate);
      const days = Math.ceil((end - start) / (1000 * 60 * 60 * 24));
      return product.rentalPrice * days * quantity;
    }
  };
const handleFileChange = (e) =>{
  const value =e.target.files && e.target.files[0];
  setPhoto(value);
}

const handleOrderSubmit = async (e) => {
  e.preventDefault(); 
  

  // Validation
  if (!hospitalName || !doctorName || !doctorPhone || !hospitalAddress) {
    Swal.fire("Error", "Please fill all required fields", "error");
    return;
  }

  if (
    orderType === "stand_by" &&
    (!startDate || !endDate || !productType || !receiverName || !receiverPhone || !notes)
  ) {
    Swal.fire("Error", "Please fill all standby product details", "error");
    return;
  }

  if (orderType === "demo" && (!startDate || !endDate)) {
    Swal.fire("Error", "Please select demo product duration", "error");
    return;
  }

  try {
    const token = localStorage.getItem("token");
    if (!token) {
      Swal.fire("Error", "Please login to place order", "error");
      navigate("/login");
      return;
    }

    // ✅ Create FormData
    const formData = new FormData();

    // Add photo only if applicable
    if (orderType === "stand_by" && photo) {
      formData.append("photo", photo); // File from <input type="file">
    }

    // Append normal fields
    formData.append("source", "sunrise-webapp");
    formData.append("product_type", orderType === "stand_by" ? productType : "");
    formData.append("notes", notes);
    formData.append("confirmed", false);
    formData.append("total", calculateTotal());

    // Append complex data (must stringify)
    const items = [
      {
        product: product.id,
        name: product.name,
        image: product.image,
        price: orderType === "buy" ? product.salePrice : product.rentalPrice,
        quantity,
        buyOrRent: orderType,
        startDate:
          orderType === "stand_by" || orderType === "demo" ? startDate : undefined,
        endDate:
          orderType === "stand_by" || orderType === "demo" ? endDate : undefined,
      },
    ];
    formData.append("items", JSON.stringify(items));

    const shippingAddress = {
      hospitalName,
      doctorName,
      doctorPhone,
      hospitalAddress,
      receiverName,
      receiverPhone,
    };
    formData.append("shippingAddress", JSON.stringify(shippingAddress));
    // ✅ Send request  
    await axios.post(`${API_URL}/orders/create`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

    Swal.fire({
      title: "Success!",
      text: "Order placed successfully",
      icon: "success",
      showConfirmButton: false,
      timer: 1500,
    });

    navigate("/orders");

    // Reset form
    setHospitalName("");
    setDoctorName("");
    setDoctorPhone("");
    setReceiverName("");
    setReceiverPhone("");
    setHospitalAddress("");
    setNotes("");
    setPhoto(null);
    setStartDate("");
    setEndDate("");
  } catch (error) {
    console.error("Error creating order:", error);
    Swal.fire("Error", "Failed to place order", "error");
  }
};

  // 📄 Download Challan (for Standby)
  const downloadChallan = () => {
    if (!hospitalName || !doctorName || !doctorPhone || !hospitalAddress) {
      Swal.fire("Error", "Please fill all required fields", "error");
      return;
    }
    if (
      orderType === "stand_by" &&
      (!startDate ||
        !endDate ||
        !productType ||
        !receiverName ||
        !receiverPhone ||
        !notes)
    ) {
      Swal.fire("Error", "Please fill all standby product details", "error");
      return;
    }

    const challan = document.getElementById("standby-challan");
    console.log("challan_data23",challan);
    const opt = {
      margin: 10,
      filename: `standby_challan_${hospitalName.replace(/\s+/g, "_")}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };   
    html2pdf().from(challan).set(opt).save();
  };

  const handlePlaceOrder = (product) => {
    const qrData = JSON.stringify({
      _id: product.id,
      name: product.name,
      category: product.category,
      salePrice: product.salePrice,
      rentalPrice: product.rentalPrice,
      created_at: new Date(product.created_at).toLocaleDateString(),
    });
    setQrValue(qrData);
    setShowQRModal(true);
  };

  const verifyQR = async () => {
    try {
      // Step 1: Parse QR value into JSON
      const parsed = JSON.parse(qrValue);

      if (!parsed._id || !parsed.category) {
        alert("❌ Invalid QR data");
        return;
      }

      // // Step 2: Call backend API to verify
      const response = await fetch(`${API_URL}/products/verify-place-order`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          product_id: parsed._id,
          category: parsed.category,
        }),
      });

      const data = await response.json();
      // // Step 3: Check API response
      if (data.success == 1) {
        alert("✅ Verified!");
        setShowQRModal(false);
        setShowOrderForm(true);
      } else {
        alert(`❌ Verification failed: ${data.message || "Unknown error"}`);
      }
    } catch (error) {
      console.error("Error verifying QR:", error);
      alert("❌ Something went wrong while verifying QR");
    }
  };

  if (loading) {
    return (
      <div className="content-page">
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 text-center">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!product) {
    return (
      <div className="content-page">
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="alert alert-danger">Product not found</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (
    !userData ||
    (userData.role !== "admin" && userData.role !== "receptionist")
  ) {
    return (
      <div className="content-page">
        <div className="content">
          <div className="container-fluid">
            <div className="alert alert-warning mt-5">
              Access denied. Only admin and receptionist can browse products.
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="content-page">
        <div className="content">
          <div className="container-fluid">
            {/* Breadcrumb */}
            <div className="row mb-4">
              <div className="col-12">
                <div className="page-title-box d-flex align-items-center justify-content-between">
                  <h4 className="mb-0 font-18">{product.name}</h4>
                  <div className="page-title-right">
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb m-0 p-0 bg-transparent">
                        <li className="breadcrumb-item">
                          <Link to="/" className="text-primary">
                            Home
                          </Link>
                        </li>
                        <li className="breadcrumb-item">
                          <Link to="/shop" className="text-primary">
                            Shop
                          </Link>
                        </li>
                        <li
                          className="breadcrumb-item active"
                          aria-current="page"
                        >
                          {product.name}
                        </li>
                      </ol>
                    </nav>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              {/* Product Image */}
              <div className="col-lg-6">
                <div className="card shadow-sm">
                  <div className="card-body p-0">
                    <div className="position-relative">
                      <img
                        src={`https://sunrise-backend.sunrisemeditechsystems.com${product.image}`}
                        alt={product.name}
                        className="img-fluid rounded"
                        style={{
                          width: "100%",
                          height: "450px",
                          objectFit: "contain",
                          backgroundColor: "#f8f9fa",
                          padding: "20px",
                        }}
                      />
                      {product.saleStock <= 0 && product.rentalStock <= 0 && (
                        <div
                          className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                          style={{ backgroundColor: "rgba(255,255,255,0.8)" }}
                        >
                          <span className="badge bg-danger px-4 py-2 fs-5">
                            Out of Stock
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Product Details */}
              <div className="col-lg-6">
                <div className="card shadow-sm">
                  <div className="card-body">
                    <h3 className="card-title mb-4">{product.name}</h3>
                    <div className="bg-light p-3 rounded mb-4">
                      <p
                        className="card-text text-dark"
                        style={{ lineHeight: "1.8" }}
                      >
                        {product.description}
                      </p>
                    </div>

                    <div className="row mb-4">
                      <div className="col-12">
                        <div
                          className="border rounded p-3 text-center"
                          style={{ backgroundColor: "rgba(25, 135, 84, 0.1)" }}
                        >
                          <h4 className="text-dark mb-1">
                            ₹{product.salePrice}
                          </h4>
                          <small className="text-dark fw-medium">
                            SALE PRICE
                          </small>
                        </div>
                      </div>
                    </div>

                    <div className="mb-4">
                      <h6 className="text-uppercase mb-3">Availability</h6>
                      <div className="d-flex gap-3">
                        {product.saleStock > 0 && (
                          <div
                            className="px-3 py-2 rounded-pill"
                            style={{
                              backgroundColor: "rgba(25, 135, 84, 0.15)",
                            }}
                          >
                            <i className="fas fa-check-circle text-success me-2"></i>
                            <span className="text-dark fw-medium">
                              Buy: {product.saleStock} available
                            </span>
                          </div>
                        )}
                        {product.rentalStock > 0 && (
                          <div
                            className="px-3 py-2 rounded-pill"
                            style={{
                              backgroundColor: "rgba(13, 110, 253, 0.15)",
                            }}
                          >
                            <i className="fas fa-clock text-primary me-2"></i>
                            <span className="text-dark fw-medium">
                              Rent: {product.rentalStock} available
                            </span>
                          </div>
                        )}
                      </div>
                    </div>

                    <button
                      className="btn btn-primary btn-lg w-100 rounded-pill fw-medium"
                      onClick={() => handlePlaceOrder(product)}
                      disabled={
                        product.saleStock <= 0 && product.rentalStock <= 0
                      }
                    >
                      <i className="fas fa-shopping-cart me-2"></i>
                      Place Order
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Order Form Modal */}
            {showOrderForm && (
              <div
                className="modal fade show"
                style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
              >
                <div className="modal-dialog modal-lg modal-dialog-centered">
                  <div className="modal-content border-0 shadow">
                    <div className="modal-header bg-primary bg-opacity-10 border-0">
                      <h5 className="modal-title text-white">
                        Place Order - {product.name}
                      </h5>
                      <button
                        type="button"
                        onClick={() => setShowOrderForm(false)}
                        className="order-btn"
                        aria-label="Close"
                      >
                        {" "}
                        ×{" "}
                      </button>
                    </div>
                    {userData &&
                      (userData.role === "admin" ||
                        userData.role === "receptionist") && (
                        // orderType === "stand_by"
                        <form
                          onSubmit={handleOrderSubmit}
                          className={orderType === "stand_by" && "product-form"}
                        >
                          <div className="modal-body">
                            <div className="row">
                              <div className="col-md-6 mb-3">
                                <label className="form-label">Order Type</label>
                                <select
                                  className="form-control form-input-length"
                                  value={orderType}
                                  onChange={(e) => setOrderType(e.target.value)}
                                >
                                  <option value="buy">Buy</option>
                                  <option value="stand_by">Stand By</option>
                                  <option value="demo">Demo</option>
                                </select>
                              </div>

                              <div className="col-md-6 mb-3">
                                <label className="form-label">Quantity</label>
                                <input
                                  type="number"
                                  className="form-control"
                                  value={quantity}
                                  onChange={(e) =>
                                    setQuantity(parseInt(e.target.value))
                                  }
                                  min="1"
                                  max={
                                    orderType === "buy"
                                      ? product.saleStock
                                      : product.rentalStock
                                  }
                                />
                              </div>
                            </div>

                            {(orderType === "stand_by" ||
                              orderType === "demo") && (
                              <div className="row">
                                <div className="col-md-6 mb-3">
                                  <label>Start Date</label>
                                  <input
                                    type="date"
                                    className="form-control form-input-length"
                                    value={startDate}
                                    onChange={(e) =>
                                      setStartDate(e.target.value)
                                    }
                                    min={new Date().toISOString().split("T")[0]}
                                  />
                                </div>
                                <div className="col-md-6 mb-3">
                                  <label>End Date</label>
                                  <input
                                    type="date"
                                    className="form-control"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                    min={
                                      startDate ||
                                      new Date().toISOString().split("T")[0]
                                    }
                                  />
                                </div>
                              </div>
                            )}

                            <div className="mb-3">
                              <label>Hospital Name *</label>
                              <input
                                type="text"
                                className="form-control"
                                value={hospitalName}
                                onChange={(e) =>
                                  setHospitalName(e.target.value)
                                }
                                required
                              />
                            </div>

                            {orderType === "stand_by" && (
                              <>
                                <div className="mb-3">
                                  <label>Product Type *</label>
                                  <select
                                    className="form-control"
                                    value={productType}
                                    onChange={(e) =>
                                      setProductType(e.target.value)
                                    }
                                    required
                                  >
                                    <option value="">-- Select Type --</option>
                                    <option value="repair">Repair</option>
                                    <option value="replaced_by">
                                      Replaced By
                                    </option>
                                  </select>
                                </div>
                              </>
                            )}

                            <div className="row">
                              <div className="col-md-6 mb-3">
                                <label>Doctor Name *</label>
                                <input
                                  type="text"
                                  className="form-control form-input-length"
                                  value={doctorName}
                                  onChange={(e) =>
                                    setDoctorName(e.target.value)
                                  }
                                  required
                                />
                              </div>
                              <div className="col-md-6 mb-3">
                                <label>Doctor Phone *</label>
                                <input
                                  type="tel"
                                  className="form-control"
                                  value={doctorPhone}
                                  maxLength={10}
                                  onChange={(e) =>
                                    setDoctorPhone(e.target.value)
                                  }
                                  required
                                />
                              </div>
                            </div>

                            {orderType === "stand_by" && (
                              <>
                                <div className="row">
                                  <div className="col-md-6 mb-3">
                                    <label>Receiver Name *</label>
                                    <input
                                      type="text"
                                      className="form-control form-input-length"
                                      value={receiverName}
                                      onChange={(e) =>
                                        setReceiverName(e.target.value)
                                      }
                                      required
                                    />
                                  </div>
                                  <div className="col-md-6 mb-3">
                                    <label>Receiver Phone *</label>
                                    <input
                                      type="tel"
                                      className="form-control"
                                      value={receiverPhone}
                                      maxLength={10}
                                      onChange={(e) =>
                                        setReceiverPhone(e.target.value)
                                      }
                                      required
                                    />
                                  </div>
                                </div>

                                <div className="mb-3">
                                  <label>Photo</label>
                                  <input
                                    type="file"
                                    className="form-control form-input-length"    
                                    onChange={handleFileChange}
                                    required
                                  />
                                </div>

                                <div className="mb-3">
                                  <label>Notes *</label>
                                  <textarea
                                    className="form-control"
                                    rows="3"
                                    value={notes}
                                    onChange={(e) => setNotes(e.target.value)}
                                    required
                                  ></textarea>
                                </div>
                              </>
                            )}

                            <div className="mb-3">
                              <label>Hospital Address *</label>
                              <textarea
                                className="form-control"
                                rows="3"
                                value={hospitalAddress}
                                onChange={(e) =>
                                  setHospitalAddress(e.target.value)
                                }
                                required
                              ></textarea>
                            </div>
                          </div>

                          <div className="modal-footer">
                            <button type="submit" className="btn btn-primary">
                              Place Order
                            </button>

                            {orderType === "stand_by" && (
                              <button
                                type="button"
                                className="btn btn-success"
                                onClick={downloadChallan}
                              >
                                Download Challan
                              </button>
                            )}
                          </div>
                        </form>
                      )}

                    {/* HIDDEN Challan Template */}
                    {orderType === "stand_by" && (
                      <div id="standby-challan">
                        <div>
                          <h2 style={{ textAlign: "center" }}>
                            Stand-By Product Challan
                          </h2>
                          <hr />
                          <p>
                            <b>Hospital Name:</b> {hospitalName}
                          </p>
                          <p>
                            <b>Doctor Name:</b> {doctorName}
                          </p>
                          <p>
                            <b>Doctor Phone:</b> {doctorPhone}
                          </p>
                          <p>
                            <b>Hospital Address:</b> {hospitalAddress}
                          </p>
                          <p>
                            <b>Receiver Name:</b> {receiverName}
                          </p>
                          <p>
                            <b>Receiver Phone:</b> {receiverPhone}
                          </p>
                          <p>
                            <b>Product Type:</b> {productType}
                          </p>
                          <p>
                            <b>Product:</b> {product.name}
                          </p>
                          <p>
                            <b>Quantity:</b> {quantity}
                          </p>
                          <p>
                            <b>Start Date:</b> {startDate}
                          </p>
                          <p>
                            <b>End Date:</b> {endDate}
                          </p>
                          <p>
                            <b>Notes:</b> {notes}
                          </p>
                          <hr />
                          <h4>Total Amount: ₹{calculateTotal()}</h4>
                          <div
                            style={{ marginTop: "40px", textAlign: "right" }}
                          >
                            <p>Authorized Signature: _____________________</p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <Modal
        show={showQRModal}
        onHide={() => setShowQRModal(false)}
        centered
        className="qr-modal"
      >
        <Modal.Header className="qr-modal-header">
          <button
            type="button"
            onClick={() => setShowQRModal(false)}
            className="order-btn"
          >
            ×
          </button>
          <Modal.Title className="qr-title">Scan & Verify QR Code</Modal.Title>
        </Modal.Header>

        <Modal.Body className="text-center qr-modal-body">
          <div style={{ textAlign: "center" }}>
            <QRCodeCanvas value={qrValue} size={200} level="H" />
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="primary"
            onClick={verifyQR} // ❌ Disabled until scan
          >
            Verify & Continue
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
